<template>
  <div v-if="isLoading">
    <LoaderIcon></LoaderIcon>
  </div>
  <div v-else class="h-full">
    <div
      class="h-full flex items-center justify-center px-4 sm:px-6 lg:px-8"
      :style="
        clientStore.getCustomBackgroundImagePath !== null
          ? 'background-image: url(' +
            clientStore.getCustomBackgroundImagePath +
            '); ' +
            'background-repeat: no-repeat; background-attachment: fixed; background-size: 100%; background-position:center;'
          : ''
      "
    >
      <DesktopVersionDeactivatedModal
        v-if="desktopDeactivatedModalOpen"
        :text="$t('web.error.desktopDeactivated')"
        @close="desktopDeactivatedModalOpen = false"
      />
      <div class="flex flex-col flex-1 h-full w-full">
        <AuthFlowModal
          :open="showOverviewModal"
          :view="showRegister"
          class="flex-1 h-full w-full"
        />
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-center items-center mt-4">
    <FooterLinks />
  </div>
</template>

<script>
import { useClientStore } from "../../store/v2/client";
import { useUserStore } from "../../store/v2/user";
import DesktopVersionDeactivatedModal from "../../components/v2/login/DesktopVersionDeactivatedModal.vue";
import bubble from "../../animations/bubbles/assessment-bubbles.json";
import LoaderIcon from "../../components/v2/loader/LoaderIcon";
import FooterLinks from "../../components/v2/layout/FooterLinks.vue";
import AuthFlowModal from "../../components/v2/login/AuthFlowModal.vue";

export default {
  name: "LoginPage",
  components: {
    AuthFlowModal,
    FooterLinks,
    LoaderIcon,
    DesktopVersionDeactivatedModal,
  },
  props: {
    msg: String,
  },
  setup() {
    const clientStore = useClientStore();
    const userStore = useUserStore();
    const redirectToAuthentication = inject("redirectToAuthentication");

    // prevent whitescreen bug on back navigation
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) {
        location.reload();
      }
    });

    return {
      clientStore,
      userStore,
      redirectToAuthentication,
    };
  },
  data() {
    return {
      registerModalOpen: false,
      desktopDeactivatedModalOpen: false,
      client: null,
      bubble,
      isLoading: true,
      showOverviewModal: true,
      showRegister: "start",
    };
  },
  async mounted() {
    if (this.$userAuthenticator.isAuthorized()) {
      await this.userStore.getUser();
    }

    if (
      this.$route.params.slug !== null &&
      this.$route.params.slug !== undefined
    ) {
      this.client = await this.clientStore
        .getClient(null, this.$route.params.slug)
        .catch((err) => {
          this.$userAuthenticator.logout();
          if (this.$route.name !== "login") {
            this.$router.push({
              name: "login",
            });
          }
        });
    }

    if (
      this.$route.params.slug === null ||
      this.$route.params.slug === undefined
    ) {
      this.clientStore.$reset();
    }

    if (
      this.client &&
      this.client.isMaintenance &&
      this.userStore.getCanBypassMaintenance !== true
    ) {
      this.redirectToMaintenance();
    }

    this.isLoading = false;
    // stay here, just show the modal
    if (
      this.$route.name === "desktopVersionDeactivated" ||
      (this.client && !this.client.desktopVersionActivated)
    ) {
      this.isLoading = false;
      this.desktopDeactivatedModalOpen = true;

      return;
    }

    if (this.$userAuthenticator.isAuthorized()) {
      this.redirectToFeed();
    }

    // this page is available under /login, /register and /desktop-deactivated
    // route /register is called from the backend's login page simply to show the registration form
    // route /login will always redirect to backend's login page but remain available to not break external links
    // route /desktop-deactivated is called from the backend's authentication flow simply to show the modal for it
    if (
      this.$route.name === "register" ||
      this.$route.name === "slugRegister"
    ) {
      this.isLoading = false;
      this.showRegister = "code";
    }
  },
  methods: {
    redirectToFeed() {
      this.$router.push({
        name: "feed",
        params: {
          slug: this.clientStore.slug,
        },
      });
    },
    redirectToLogin() {
      this.redirectToAuthentication({
        clientCode: this.$route.params.slug,
      });
    },
    redirectToMaintenance() {
      this.$router.push({
        name: "maintenancePage",
      });
    },
  },
};
</script>
